var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cu",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0050f0",
    d: "M-32 0h768v512H-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-32 102.4h768v102.4H-32zm0 204.8h768v102.4H-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed0000",
    d: "m-32 0 440.7 255.7L-32 511V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161.8 325.5 114.3 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3 18 58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCu);
export default __webpack_public_path__ + "static/media/cu.06cc0c5fe355c7e990030146ccef12fc.svg";
export { ForwardRef as ReactComponent };